import React from "react";
import styled from "styled-components";

const HeaderContainer = styled.div``;

const Title = styled.h1`
  color: rgba(100, 181, 246, 1);
  font-size: 125%;

`;

const Header = () => (
  <HeaderContainer>
    <Title>Fibonacci Times</Title>
  </HeaderContainer>
);

export default Header;
